// Add to cart
export const addToCart = (data) => (dispatch, getState) => {
  try {
    dispatch({
      type: "addToCart",
      payload: data,
    });

    // Save updated cart to localStorage
    const updatedCart = getState().cart.cart;
    localStorage.setItem("cartItems", JSON.stringify(updatedCart));
    return updatedCart;
  } catch (error) {
    console.error("Error adding to cart:", error);
    throw error;
  }
};

// Remove from cart
export const removeFromCart = (data) => async (dispatch, getState) => {
  dispatch({
    type: "removeFromCart",
    payload: data._id,
  });
  localStorage.setItem("cartItems", JSON.stringify(getState().cart.cart));
  return data;
};

// Clear cart
export const clearCart = () => (dispatch, getState) => {
  try {
    dispatch({
      type: "clearCart",
    });

    // Clear cart from localStorage
    localStorage.setItem("cartItems", JSON.stringify([]));
    return [];
  } catch (error) {
    console.error("Error clearing cart:", error);
    throw error;
  }
};

